import React from "react";

import PrivateLayout from "../layout/PrivateLayout";
import PublicLayout from "../layout/PublicLayout";
import { Dashboard } from "../pages";
import AddUser from "../pages/AddUser";
import admin from "../pages/Admin";
import AddAdmin from "../pages/Admin/AddAdmin";
import AdminDetails from "../pages/Admin/Details";
import UpdateAdminPassword from "../pages/Admin/UpdateAdminPassword";
import Bookings from "../pages/Bookings";
import BookingDetails from "../pages/Bookings/Details";
import Contract from "../pages/Contract";
import EditUser from "../pages/EditUser";
import ForgotPassword from "../pages/Forgotpassword";
import SetPasswordForget from "../pages/Forgotpassword/SetPassword/index";
import GlobalSettings from "../pages/GlobalSettings";
import Jobs from "../pages/Jobs";
import JobDetails from "../pages/Jobs/Details";
import Login from "../pages/Login";
import Notifications from "../pages/Notification/Notifications";
import Profile from "../pages/Profile";
import Properties from "../pages/Properties";
import PropertyDetails from "../pages/Properties/Details";
import Review from "../pages/Properties/Details/review";
import UpdateProperty from "../pages/Properties/UpdateProperty";
import Reports from "../pages/Reports";
import Report from "../pages/Reports/Detail";
import Scrapped from "../pages/Scraped";
import { Amenities, Employer } from "../pages/Settings";
import Users from "../pages/Users";
import UserDetails from "../pages/Users/Details";
import TransactionDetails from "../pages/Users/Details/TransactionDetail/TransactionDetails";
import {
  ADD_ADMIN_ROUTE,
  ADD_USER_ROUTE,
  ADMIN_DETAILS_ROUTE,
  ADMIN_ROUTE,
  AMENITIES_ROUTE,
  BOOKING_DETAILS_ROUTE,
  BOOKING_ROUTE,
  CONTRACT_ROUTE,
  DASHBOARD_ROUTE,
  DEV_ROUTE_DETAILS_ROUTE,
  EDIT_USER_ROUTE,
  EMPLOYERS_ROUTE,
  FORGOT_PASSWORD_RESET_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  // EMPLOYERS_ROUTE_DETAILS_ROUTE,
  JOBS_DETAILS_ROUTE,
  JOBS_ROUTE,
  LOGIN_ROUTE,
  MARKETPLACE_RESOURCE,
  Notification_ROUTE,
  PROFILE_ROUTE,
  PROPERTIES_DETAILS_ROUTE,
  PROPERTIES_REVIEW_ROUTE,
  PROPERTIES_ROUTE,
  PROPERTIES_UPDATE_ROUTE,
  PROPERTY_RESOURCE,
  RATING_RESOURCE,
  REPORT_ROUTE,
  REPORTS_ROUTE,
  SCRAPPED_ROUTE,
  TRADE_RESOURCE,
  UPDATE_PASSWORD_ROUTE,
  USERS_DETAILS_ROUTE,
  USERS_ROUTE,
  USERS_TRANSACTION_DETAIL_ROUTE,
} from "./routePaths";
import PropertyResource from "../pages/Resources/PropertyResource";
import MarketplaceResource from "../pages/Resources/MarketplaceResource";
import TradeResource from "../pages/Resources/TradeResource";
import RatingResource from "../pages/Resources/RatingResource";

const routes: IRoutes[] = [
  {
    id: 50,
    path: LOGIN_ROUTE,
    component: Login,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 65,
    path: FORGOT_PASSWORD_ROUTE,
    component: ForgotPassword,
    children: [
      {
        id: 65_1,
        component: SetPasswordForget,
        path: FORGOT_PASSWORD_RESET_ROUTE,
      },
    ],
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },

  {
    id: 100,
    path: DASHBOARD_ROUTE,
    component: Dashboard,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: ["admin"],
  },
  {
    id: 100,
    path: DASHBOARD_ROUTE,
    component: Dashboard,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: ["OPERATOR"],
  },
  {
    id: 123,
    path: Notification_ROUTE,
    component: Notifications,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 304,
    path: ADD_USER_ROUTE,
    component: AddUser,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 304,
    path: ADD_ADMIN_ROUTE,
    component: AddAdmin,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 304,
    path: EDIT_USER_ROUTE,
    component: EditUser,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 304,
    path: DEV_ROUTE_DETAILS_ROUTE,
    component: GlobalSettings,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 304,
    path: CONTRACT_ROUTE,
    component: Contract,
    layout: PrivateLayout,
    isProtected: true,
  },

  {
    id: 200,
    path: PROPERTIES_ROUTE,
    component: Properties,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 200_1,
        component: PropertyDetails,
        path: PROPERTIES_DETAILS_ROUTE,
      },

      {
        id: 200_2,
        component: UpdateProperty,
        path: PROPERTIES_UPDATE_ROUTE,
      },
      {
        id: 200_3,
        component: Review,
        path: PROPERTIES_REVIEW_ROUTE,
      },
    ],
  },
  {
    id: 300,
    path: BOOKING_ROUTE,
    component: Bookings,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 300_1,
        component: BookingDetails,
        path: BOOKING_DETAILS_ROUTE,
      },
    ],
  },
  {
    id: 400,
    path: USERS_ROUTE,
    component: Users,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 400_1,
        component: UserDetails,
        path: USERS_DETAILS_ROUTE,
        children: [
          {
            id: 400_2,
            component: TransactionDetails,
            path: USERS_TRANSACTION_DETAIL_ROUTE,
          },
        ],
      },
    ],
  },

  {
    id: 1000,
    path: ADMIN_ROUTE,
    component: admin,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 1000_1,
        component: AdminDetails,
        path: ADMIN_DETAILS_ROUTE,
      },
    ],
  },
  {
    id: 500,
    path: JOBS_ROUTE,
    component: Jobs,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 500_1,
        component: JobDetails,
        path: JOBS_DETAILS_ROUTE,
      },
    ],
  },
  {
    id: 600,
    path: PROFILE_ROUTE,
    component: Profile,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 700,
    path: REPORTS_ROUTE,
    component: Reports,
    layout: PrivateLayout,
    isProtected: true,
    children: [
      {
        id: 500_1,
        component: Report,
        path: REPORT_ROUTE,
      },
    ],
  },

  {
    id: 800,
    path: SCRAPPED_ROUTE,
    component: Scrapped,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 900,
    path: UPDATE_PASSWORD_ROUTE,
    component: UpdateAdminPassword,
    layout: PublicLayout,
    isProtected: false,
  },
  // {
  //   id: 1000,
  //   path: UTILITY_CATEGORIES_ROUTE,
  //   component: UtilityCategories,
  //   layout: PrivateLayout,
  //   isProtected: true,
  // },
  // {
  //   id: 1100,
  //   path: UTILITY_PROVIDERS_ROUTE,
  //   component: UtilityProviders,
  //   layout: PrivateLayout,
  //   isProtected: true,
  //   children: [
  //     {
  //       id: 1100_1,
  //       component: ProviderDetails,
  //       path: UTILITY_PROVIDER_DETAILS_ROUTE,
  //     },
  //   ],
  // },
  {
    id: 1200,
    path: AMENITIES_ROUTE,
    component: Amenities,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 1300,
    path: EMPLOYERS_ROUTE,
    component: Employer,
    layout: PrivateLayout,
    isProtected: true,
  },

  {
    id: 1950,
    path: PROPERTY_RESOURCE,
    component: PropertyResource,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 1951,
    path: MARKETPLACE_RESOURCE,
    component: MarketplaceResource,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 1952,
    path: TRADE_RESOURCE,
    component: TradeResource,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 1953,
    path: RATING_RESOURCE,
    component: RatingResource,
    layout: PrivateLayout,
    isProtected: true,
  },
];
export default routes;

export interface IRoutes {
  id: number;
  path: string;
  component: React.FC;
  layout: React.FC<React.PropsWithChildren<{ extraInfo?: any }>>;
  isProtected?: boolean;
  redirectToOnAuth?: string;
  role?: string[];
  restrictTo?: string[];
  allowTo?: string[];
  children?: Array<IChildren>;
  extraInfo?: any;
}

export interface IChildren {
  id: number;
  path: string;
  component: React.FC;
  children?: Array<IChildren>;
}
